import { render, staticRenderFns } from "./BoningReport.vue?vue&type=template&id=d46a076e"
import script from "./BoningReport.vue?vue&type=script&lang=js"
export * from "./BoningReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports